/**
 * Startsida D — scroll reveal + Ceramika pin + mobile hero intro.
 * Behaviour mirrored from docs/mockup-startsida HTML/JS.
 */
(function () {
  var root = document.querySelector("[data-home-fendi]");
  if (!root) return;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Mobile hero intro: class "loaded" on root (mockup uses body.loaded) */
  function markLoaded() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.classList.add("loaded");
      });
    });
  }
  if (reduce) {
    root.classList.add("loaded");
  } else if (document.readyState === "complete") {
    markLoaded();
  } else {
    window.addEventListener("load", markLoaded);
  }

  /* Ceramika: pin to banner bottom + black→white when over image */
  var cerImg = root.querySelector("[data-hf-cer-img]");
  var cerTxt = root.querySelector("[data-hf-cer-text]");
  function pinCer() {
    if (!cerImg || !cerTxt) return;
    cerTxt.style.top = cerImg.offsetHeight - cerTxt.offsetHeight + "px";
  }
  function colorCer() {
    if (!cerImg || !cerTxt) return;
    var a = cerImg.getBoundingClientRect();
    var b = cerTxt.getBoundingClientRect();
    /* desktop mockup uses +30, mobile +24 — use 30 */
    cerTxt.classList.toggle("on-image", b.top + 30 < a.bottom);
  }
  window.addEventListener("resize", pinCer);
  window.addEventListener("load", pinCer);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(pinCer);
  window.addEventListener("scroll", colorCer, { passive: true });
  pinCer();
  colorCer();

  /* Reveal: 90ms stagger, class "in", threshold ~0.12–0.15 */
  var reveals = root.querySelectorAll(".reveal");
  reveals.forEach(function (block) {
    var parts;
    if (block.getAttribute("aria-label") === "Kategorier" || block.classList.contains("home-fendi__cats")) {
      parts = block.children;
    } else if (block.querySelector(".stagger")) {
      parts = block.querySelectorAll(".stagger > *");
    } else {
      parts = block.children;
    }
    Array.prototype.forEach.call(parts, function (el, i) {
      el.style.transitionDelay = i * 90 + "ms";
    });
  });

  if (reduce) {
    reveals.forEach(function (el) {
      el.classList.add("in");
    });
  } else {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          e.target.classList.toggle("in", e.isIntersecting);
        });
      },
      { threshold: 0.14 }
    );

    var started = false;
    var atTop = false;

    function startReveal() {
      if (started) return;
      started = true;
      reveals.forEach(function (el) {
        io.observe(el);
      });
    }

    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    window.scrollTo(0, 0);

    function userScroll() {
      window.removeEventListener("wheel", userScroll);
      window.removeEventListener("touchmove", userScroll);
      window.removeEventListener("keydown", userKey);
      startReveal();
    }
    function userKey(e) {
      if (["ArrowDown", "PageDown", " ", "End"].indexOf(e.key) >= 0) userScroll();
    }
    window.addEventListener("wheel", userScroll, { passive: true });
    window.addEventListener("touchmove", userScroll, { passive: true });
    window.addEventListener("keydown", userKey);

    window.addEventListener(
      "scroll",
      function () {
        if (!started && window.scrollY > 4) startReveal();
        if (window.scrollY < 4) {
          atTop = true;
          root.querySelectorAll(".reveal.in").forEach(function (el) {
            el.classList.remove("in");
          });
        } else if (atTop) {
          atTop = false;
          reveals.forEach(function (el) {
            io.unobserve(el);
            io.observe(el);
          });
        }
      },
      { passive: true }
    );
  }

  /* Upptäck mer arrows — one card at a time */
  var more = root.querySelector("[data-hf-more]");
  if (!more) return;
  var row = more.querySelector("[data-hf-more-row]");
  var prev = more.querySelector("[data-hf-more-prev]");
  var next = more.querySelector("[data-hf-more-next]");
  if (!row || !prev || !next) return;

  function step(dir) {
    var card = row.children[0];
    if (!card) return;
    var gap = parseFloat(getComputedStyle(row).columnGap) || 16;
    row.scrollBy({
      left: dir * (card.getBoundingClientRect().width + gap),
      behavior: "smooth",
    });
  }
  prev.addEventListener("click", function () {
    step(-1);
  });
  next.addEventListener("click", function () {
    step(1);
  });
  function arrowState() {
    var max = row.scrollWidth - row.clientWidth - 2;
    prev.style.opacity = row.scrollLeft > 2 ? "1" : ".35";
    next.style.opacity = row.scrollLeft < max ? "1" : ".35";
  }
  row.addEventListener("scroll", arrowState, { passive: true });
  window.addEventListener("resize", arrowState);
  arrowState();
})();
